"use strict";

var _classCallCheck = require("/home/runner/work/bachelor-user-frontend/bachelor-user-frontend/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/home/runner/work/bachelor-user-frontend/bachelor-user-frontend/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");
var _inherits = require("/home/runner/work/bachelor-user-frontend/bachelor-user-frontend/node_modules/react-scripts/node_modules/@babel/runtime/helpers/inherits");
var _possibleConstructorReturn = require("/home/runner/work/bachelor-user-frontend/bachelor-user-frontend/node_modules/react-scripts/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/home/runner/work/bachelor-user-frontend/bachelor-user-frontend/node_modules/react-scripts/node_modules/@babel/runtime/helpers/getPrototypeOf");
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Closeable = void 0;
var events_1 = require("events");
var uuidv4 = require("uuid");
var Closeable = /*#__PURE__*/function (_events_1$EventEmitte) {
  _inherits(Closeable, _events_1$EventEmitte);
  var _super = _createSuper(Closeable);
  function Closeable() {
    var _this;
    _classCallCheck(this, Closeable);
    _this = _super.call(this);
    _this.closed = false;
    _this.uuid = uuidv4();
    return _this;
  }
  _createClass(Closeable, [{
    key: "listenerUuid",
    get: function get() {
      return this.uuid;
    }
  }, {
    key: "close",
    value: function close() {
      this.removeAllListeners();
      this.closed = true;
    }
  }, {
    key: "ensureNotClosed",
    value: function ensureNotClosed() {
      if (this.closed) {
        throw new Error('Invalid operation on closed object');
      }
    }
  }]);
  return Closeable;
}(events_1.EventEmitter);
exports.Closeable = Closeable;
exports.default = Closeable;